export class Economy {
  private _cash: number;
  private _lives: number;
  constructor(cash: number, lives: number) {
    this._cash = cash;
    this._lives = lives;
  }
  get cash(): number {
    return this._cash;
  }
  get lives(): number {
    return this._lives;
  }
  get dead(): boolean {
    return this._lives <= 0;
  }
  canAfford(n: number): boolean {
    return this._cash >= n;
  }
  spend(n: number): boolean {
    if (this._cash < n) return false;
    this._cash -= n;
    return true;
  }
  earn(n: number): void {
    this._cash += n;
  }
  loseLife(n = 1): void {
    this._lives = Math.max(0, this._lives - n);
  }
  /** Restore the life count. Test Arena only — used by the Clear Wave reset. */
  resetLives(n: number): void {
    this._lives = n;
  }
}
